<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Mondo virtuale in 3D.</h3>

  <p class="w-500 neutral-100 px-2 px-xl-5">
    E' un gioco di costruzione ed esplorazione dove si può interagire con il
    mondo di gioco posizionando e rompendo vari tipi di blocchi in un ambiente
    tridimensionale. Offre la
    <span class="underline-a">
      possibilità di muoversi liberamente all’interno del mondo virtuale</span
    >, dando la libertà di porre delle finalità proprie, di interagire con
    l’ambiente e ciò che lo popola
  </p>
</div>

<div class="third">
  <div class="row">
    <img
      src="../../../../assets/img/mc-1.png"
      alt="Minecraft"
     
      class="mc-1"
    />
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    Strategia, creatività e problem solving.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Minecraft è un eccellente strumento educativo. Agendo sui blocchi i ragazzi
    possono manipolare il mondo intorno a loro, costruire e distruggere
    strutture. Questo consente di
    <span class="underline-b">migliorare importanti competenze</span> di base,
    come
    <span class="underline-p">la logica, la strategia, la creatività</span> e il
    problem solving.
  </p>
</div>

<div class="fifth">
  <div class="row">
    <img
      src="../../../../assets/img/mc-2.png"
      alt="Minecraft"
     
      class="mc-1"
    />
  </div>
</div>

<div class="sixth container grid">
  <h3 class="w-700 blue-50 text-center">
    Usato dagli educatori in oltre 115 paesi.
  </h3>
</div>

<div class="seventh">
  <div class="row">
    <img
      src="../../../../assets/img/mc-3.png"
      alt="Minecraft"
     
      class="mc-1"
    />
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
